// removed by extract-text-webpack-plugin
module.exports = {"footer":"_2OuEb2LXg5doUuX1h1lMCw"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/Footer/style.scss
// module id = 609
// module chunks = 0